import { features } from '@/mocks/homepage';

export default function FeaturesSection() {
  return (
    <section id="features" className="relative py-16 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么5000万剧迷选择四虎影视大全
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={item.id}
              className="bg-background-100 border border-background-200/50 rounded-xl p-6 md:p-8 text-center hover:border-background-300/50 transition-all duration-200"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl mb-5 ${
                idx === 0 ? 'bg-primary-500/12' : idx === 1 ? 'bg-accent-500/12' : 'bg-secondary-500/12'
              }`}>
                <i className={`${item.icon} text-2xl md:text-3xl ${
                  idx === 0 ? 'text-primary-400' : idx === 1 ? 'text-accent-400' : 'text-secondary-400'
                }`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-950 font-heading mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}